import axios from '@src/public/utils/request';

// 解析链接
export const linkAnalyze = async link => {
    const res = await axios.get(
        `https://shankapi.ifeng.com/linkall//outLink/handleOutLink?link=${encodeURIComponent(link)}`,
    );

    return res;
};
